module.exports = __webpack_public_path__ + "static/Ciutadella-Regular-b829f6e40dbb9fc8c68f8f3d45065ba8.woff2";